import React from "react";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";
import "./ReviewsSection.css";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import berniq from "../../../../../assets/images/Berniq Airways.jpeg";
import areen from "../../../../../assets/images/areen co.jpeg";
import rayan from "../../../../../assets/images/rayan holding.jpg";
import rayhan from "../../../../../assets/images/rayhan company.jpeg";
import manmade from "../../../../../assets/images/Man-Made River Project Authority.jpeg";
import benghazi from "../../../../../assets/images/Benghazi Specialized Hospital.jpeg";
import marwa from "../../../../../assets/images/Al Marwa motel.jpeg";
import waha from "../../../../../assets/images/Al Waha Food Company.jpeg";
import dar from "../../../../../assets/images/Dar Al Shifa Hospital.jpeg";

function ReviewsSection() {
  const { t } = useTranslation("home");
  console.log(i18n.language);
  return (
    <section className="reviews-section">
      <div className="container">
        <h2>{t("reviewsSection.heading")}</h2>
      </div>
      <div className="container reviews-section-container">
        <Splide
          options={{
            arrows: false,
            pagination: true,
            type: "loop",
            perPage: 1,
            autoplay: true,
            interval: 4000,
            gap: "20px",
            direction: i18n.language === "AR" ? "rtl" : "ltr",
          }}
          aria-label="My Favorite Images"
          className="reviews-slider"
        >
          <SplideSlide>
            <p className="small">{t("reviewsSection.firstCardContent")}</p>
            <div className="reviwer-info">
              <picture>
                <img src={berniq} alt="" srcset="" />
              </picture>
              <div>
                <h4>{t("reviewsSection.firstCardName")}</h4>
                {/* <span>{t("reviewsSection.firstCardRole")}</span> */}
              </div>
            </div>
          </SplideSlide>
          <SplideSlide>
            <p className="small">{t("reviewsSection.secoundCardContent")}</p>
            <div className="reviwer-info">
              <picture>
                <img src={rayan} alt="" srcset="" />
              </picture>
              <div>
                <h4>{t("reviewsSection.secoundCardName")}</h4>
              </div>
            </div>
          </SplideSlide>
          <SplideSlide>
            <p className="small">{t("reviewsSection.thirdCardContent")}</p>
            <div className="reviwer-info">
              <picture>
                <img src={rayhan} alt="" srcset="" />
              </picture>
              <div>
                <h4>{t("reviewsSection.thirdCardName")}</h4>
              </div>
            </div>
          </SplideSlide>
          <SplideSlide>
            <p className="small">{t("reviewsSection.fifthCardContent")}</p>
            <div className="reviwer-info">
              <picture>
                <img src={manmade} alt="" srcset="" />
              </picture>
              <div>
                <h4>{t("reviewsSection.fifthCardName")}</h4>
              </div>
            </div>
          </SplideSlide>
          <SplideSlide>
            <p className="small">{t("reviewsSection.sixthCardContent")}</p>
            <div className="reviwer-info">
              <picture>
                <img src={benghazi} alt="" srcset="" />
              </picture>
              <div>
                <h4>{t("reviewsSection.sixthCardName")}</h4>
              </div>
            </div>
          </SplideSlide>
          <SplideSlide>
            <p className="small">{t("reviewsSection.seventhCardContent")}</p>
            <div className="reviwer-info">
              <picture>
                <img src={marwa} alt="" srcset="" />
              </picture>
              <div>
                <h4>{t("reviewsSection.seventhCardName")}</h4>
              </div>
            </div>
          </SplideSlide>
          <SplideSlide>
            <p className="small">{t("reviewsSection.eigthCardContent")}</p>
            <div className="reviwer-info">
              <picture>
                <img src={waha} alt="" srcset="" />
              </picture>
              <div>
                <h4>{t("reviewsSection.eigthCardName")}</h4>
              </div>
            </div>
          </SplideSlide>
          <SplideSlide>
            <p className="small">{t("reviewsSection.ninethCardContent")}</p>
            <div className="reviwer-info">
              <picture>
                <img src={dar} alt="" srcset="" />
              </picture>
              <div>
                <h4>{t("reviewsSection.ninethCardName")}</h4>
              </div>
            </div>
          </SplideSlide>
        </Splide>
      </div>
    </section>
  );
}

export default ReviewsSection;
